module.exports = __webpack_public_path__ + "img/art1.3ca17ae7.gif";